import api from './api';
import {
  GET_FARM_ENTITIES_SERVICE_URL,
  GET_FARM_STATE_SERVICE_URL,
} from '../api/lelyBackend/config';
import { Nullable } from '@/common/types';
import { System } from './availableSystemApi';

export type EntityType = {
  isAvailable: boolean;
  name: string;
  type: string;
  stateColor: string;
  id: string;
  kpis: [];
  uri: string;
};

export type FarmDetailsType = {
  entities: Nullable<EntityType[]>;
  id: string;
  farmName: string;
  farmTimeZone: string;
  customerName: string;
};

export type GetFarmDetailsArgs = {
  farmId: string;
  preferredSystems: System[];
};

export type EntityStateType = {
  name: string;
  stateColor: string;
  type?: string;
};

export type FarmState = {
  entitiesState: EntityStateType[];
  farmRingBufferEnabled: boolean;
};

export const farmDetailsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getFarmDetails: build.query<FarmDetailsType, GetFarmDetailsArgs>({
      query: ({ farmId, preferredSystems = [] }) => {
        const params = new URLSearchParams();

        preferredSystems.forEach((system) => {
          params.append('preferredSystems', system.id);
        });

        const queryString = params.toString();
        const url = queryString
          ? `${GET_FARM_ENTITIES_SERVICE_URL}${farmId}?${queryString}`
          : `${GET_FARM_ENTITIES_SERVICE_URL}${farmId}`;
        return url;
      },
      providesTags: ['FarmDetails'],
    }),

    getFarmState: build.query<FarmState, string>({
      query: (farmId) => ({
        url: `${GET_FARM_STATE_SERVICE_URL}${farmId}`,
      }),
      providesTags: ['FarmState'],
    }),
  }),
});

export const { useGetFarmDetailsQuery, useGetFarmStateQuery } = farmDetailsApi;
